import React, { useContext } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { SessionContext } from '../../contexts/SessionContext'

type RouteHelperProps = RouteProps

export const PrivateRoute: React.FC<RouteHelperProps> = ({ children, ...other }) => {
  const session = useContext(SessionContext)

  return (
    <Route
      {...other}
      render={props =>
        session.loggedIn ? (
          <>
            { children }
          </>
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  )
}

export const PublicRoute: React.FC<RouteHelperProps> = ({ children, ...other }) => {
  const session = useContext(SessionContext)

  return (
    <Route
      {...other}
      render={props =>
        session.loggedIn ? (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        ) : (
          <>
            { children }
          </>
        )
      }
    />
  )
}
